import Vue from 'vue';
import VueResource from 'vue-resource';
import LoadingSpinner from '../vue/LoadingSpinner';
let projects = document.querySelector('#projects');

Vue.use(VueResource);

if(projects != null) {

// Intiate Vuejs instance
var app = new Vue({
    el: '#projects',
    delimiters: ["${","}"],
    components: {
        LoadingSpinner
    },
    data: function () {
        return {
            items: [],
            nextPage: 0,
            showSpinner: true,
            total: '',
            perPage: '',
            count: ''
        }
    },
    methods : {
        loadMoreProjects: function() {
            this.showSpinner = true;
            this.$http.get('/api/v1/projects.json?pg=' + this.nextPage).then(function(data) {
                this.count = this.nextPage * this.perPage;
                this.items = this.items.concat(data.body.data);
                this.nextPage = this.nextPage + 1;
                if (data.body.meta.pagination.total_pages == data.body.meta.pagination.current_page)
                    this.nextPage = 0;
                this.showSpinner = false;
            });
        },
    },
    created: function() {
        this.$http.get('/api/v1/projects.json').then(function(data) {
            if (data.body.meta.pagination.total_pages > 1)
                this.nextPage = 2;
            this.total = data.body.meta.pagination.total;
            this.perPage = data.body.meta.pagination.per_page;
            this.count = data.body.meta.pagination.count;
            this.showSpinner = false;
        });
    }
})
}